<template>
    <div>
        <!-- Modal Inclusão no Programa -->
        <div class="modal fade" id="incluirProgramaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Incluir Programa</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="paciente">
                            <div>{{ paciente.st_nome }}</div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Programa"
                                    placeholder="Selecione o programa"
                                    type="autocomplete"
                                    service="cuidado_programas.index"
                                    optionsData="id_cuidado_programa"
                                    required
                                    :validate="validate"
                                    v-model="edicao.id_cuidado_programa" />
                            </div>
                        </div>

                        <div class="form-row my-3">
                            <div class="col col-12 col-md-6">
                                <az-periodo v-model="filtro" :sync="true" @sync="load_marcacoes()" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    icon="fa fa-search"
                                    placeholder="Pesquisar..."
                                    v-model="filtro.search" />
                            </div>
                        </div>

                        <az-empty-state v-if="!lista_marcacoes.length" />

                        <div v-else>

                            <az-sub-title title="Selecione o Atendimento de Origem"></az-sub-title>

                            <div class="list-group">
                                <button type="button" 
                                    :class="edicao.id_atendimento === marcacao.id_atendimento ? 'active' : ''"
                                    class="list-group-item list-group-item-action d-flex justify-content-between" 
                                    v-for="(marcacao, imx) in lista_marcacoes" 
                                    :key="imx" 
                                    @click="edicao.id_atendimento = marcacao.id_atendimento">
                                    <div>
                                        <div>{{ marcacao.procedimento.search }}</div>
                                        <div>{{ marcacao.medico.search }}</div>
                                    </div>
                                    <div class="text-right">
                                        <div>#{{ marcacao.id_atendimento }}</div>
                                        <div>{{ $util.getFormatDate(marcacao.dt_inicio) }}</div>
                                    </div>
                                </button>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            paciente: null,
            edicao: { 
                id_cuidado_programa: "",
                id_atendimento: "", 
                index: null, 
            },
            marcacoes: null, 
            filtro: { 
                periodo: "m",
                search: "" 
            },
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        AzSubTitle, 
        AzPeriodo, 
        AzSubmit, 
    },

    computed: { 
        lista_marcacoes: function () { 
            if ( !this.marcacoes )
                return [];

            let regex = this.$util.getregex(this.filtro.search);

            return this.marcacoes.filter( marcacao => { 
                return !this.filtro.search 
                    || marcacao.id_atendimento == this.edicao.id_atendimento
                    || regex.test(JSON.stringify(marcacao));
            });
        }
    },
    
    methods: { 
        load_marcacoes() { 
            this.edicao.id_atendimento = null; 
            this.marcacoes = null;
            
            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'index',
                parms: { 
                    id_paciente: this.paciente.id_pessoa, 
                    buscar_herdar: true, 
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.marcacoes = res;
                }
            })
        }, 

        incluir_programa(paciente) { 
            this.validate = false;
            this.marcacoes = null;
            this.edicao.id_cuidado_programa = "";
            this.edicao.id_atendimento = "";
            
            this.paciente = _.cloneDeep(paciente);

            this.load_marcacoes();

            $('#incluirProgramaModal').modal('show');
        },

        atualizar () { 

            if ( !this.edicao.id_atendimento ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção!', 
                    detail: 'Selecione o atendimento de origem.',
                    life: 5000 
                });
            }

            this.$util.atualizar(this, { 
                service: 'crm',
                func: 'incluir_no_programa',
                dados: { 
                    id_cuidado_programa: this.edicao.id_cuidado_programa,
                    lista: [
                        { 
                            id_atendimento: this.edicao.id_atendimento,
                            id_paciente: this.paciente.id_pessoa,
                        }
                    ]
                },
                modal: 'incluirProgramaModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        },

    }
}
</script>
